import React from 'react'
import { Circles } from  'react-loader-spinner'
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import PropTypes from 'prop-types'
function Loader(props) {  
    const {eventsLoader, width, height} = props

	return (
        <div className= {eventsLoader ? 'eventsloader d-flex justify-content-center align-items-center' : 'loader d-flex justify-content-center align-items-center'}>
            <Circles
                height={height ? height: '60'}
                width={width ? width : '60'}
                color="#060D63"
                ariaLabel="circles-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>
        
        )
}
Loader.propTypes = {
	
	eventsLoader: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string,
}

Loader.defaulProps = {
	
	eventsLoader: false,
    width: '60',
    height: '60'
	
}
export default Loader
